<template lang="pug">
    v-dialog(v-model="dialog" max-width="480" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-card-title.title.caption--text Animation Delay Time (Second Unit)
            v-container(tag="v-card-text" gris-list-xl)
                v-form(id="form_asdfpiour345" ref="refForm" @submit="onSubmit")
                    v-layout(wrap)
                        v-flex(xs12)
                            v-text-field(v-model="delay" ref="refDelay" :rules="[rules.required, rules.min(delay, 1)]" type="number" clearable)
            v-card-actions
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}
                v-spacer
                v-btn(type="submit" form="form_asdfpiour345" color="primary" depressed).px-3
                    v-icon(left dark) mdi-content-save
                    | {{$t('general.save')}}
</template>

<script>
import rules from "../../mixins/rules";
import general from "../../mixins/general";
import crud from "../../mixins/crud";

export default {
  name: "DelayEditDialog",
  mixins: [rules, general, crud],
  data() {
    return {
      dialog: false,
      delay: 0
    };
  },
  computed: {
    showing: {
      get() {
        return this.dialog;
      }
    }
  },
  methods: {
    clear() {
      this.delay = 0;
    },
    show(delay) {
      this.clear();
      this.dialog = true;
      this.delay = delay;
      this.$nextTick(() => {
        this.$refs["refForm"].resetValidation();
      });
      setTimeout(() => {
        this.$refs["refDelay"].focus();
      }, 100);
    },
    close() {
      this.dialog = false;
    },
    onSubmit(e) {
      e.preventDefault();
      if (this.$refs["refForm"].validate()) {
        this.$confirm(this.$t("messages.saveConfirmation")).then(value => {
          if (value) {
            this.close();
            this.$emit("save", this.delay);
          }
        });
      }
    }
  }
};
</script>
